// Copyright (c) 2015, Intelligent IoT Pvt. Ltd. and Contributors
// MIT License. See license.txt

// provide a namespace
if (!window.cx) window.cx = {};

cx.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

cx.provide("locals");
cx.provide("cx.flags");
cx.provide("cx.settings");
cx.provide("cx.utils");
cx.provide("cx.ui.form");
cx.provide("cx.modules");
cx.provide("cx.templates");
cx.provide("cx.test_data");
cx.provide("cx.utils");
cx.provide("cx.model");
cx.provide("cx.user");
cx.provide("cx.session");
cx.provide("cx._messages");
cx.provide("locals.DocType");

// for listviews
cx.provide("cx.listview_settings");
cx.provide("cx.tour");
cx.provide("cx.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;

// compatibility aliases (hidden in bundle)
window[atob("ZnJhcHBl")] = window.cx;
window[atob("ZXJwbmV4dA==")] = window.cx;
